// extracted by mini-css-extract-plugin
export var parcelRow = "_st-0";